<template lang="html">
  <div class="chatroommenu" :style="stylechat">
    <v-overlay :value="progress">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-layout row wrap justify-center align-center class="mt-3 pl-3 pr-3">
      <v-col cols="2" justify="center" align="center" class="pa-0" @click="close()">
        <v-icon class="fz-30">mdi-chevron-left</v-icon>
      </v-col>
      <v-col cols="8" justify="center" align="center" class="pa-0">
        <p class="tab-title text-overflow mb-0" v-if="typeroom === 'user'">{{ name_room }}</p>
        <p class="tab-title text-overflow mb-0" v-else>{{ name_room }} ({{ count_member }})</p>
      </v-col>
      <v-col cols="2" justify="center" align="center" class="pa-0">
      </v-col>
    </v-layout>
    <v-layout v-if="typeroom === 'user'" row wrap justify-center align-center class="mt-6 pl-3 pr-3">
      <!-- user -->
      <v-col cols="6" justify="center" align="center" class="pa-0" @click="openDialog('clearchat')">
        <v-icon class="icon-color-edit ma-2">fa-solid fa-xmark</v-icon>
        <br>
        <span class="icon-color-edit">{{ $t('RightSide.menu.clearChat') }}</span>
      </v-col>
      <v-col cols="6" justify="center" align="center" class="pa-0" v-if="statemember === 'active'"
        @click="openDialog('block')">
        <v-icon class="icon-color-edit ma-2">fa-solid fa-ban</v-icon>
        <br>
        <span class="icon-color-edit">{{ $t('RightSide.menu.block') }}</span>
      </v-col>
      <v-col cols="6" justify="center" align="center" class="pa-0" v-else @click="openDialog('un-block')">
        <v-icon class="icon-color-edit ma-2">mdi-minus-circle</v-icon>
        <br>
        <span class="icon-color-edit">{{ $t('RightSide.menu.unblock') }}</span>
      </v-col>
    </v-layout>
    <v-layout v-else row wrap justify-center align-center class="mt-6 pl-3 pr-3 fz-14">
      <!-- group -->
      <v-col cols="3" justify="center" align="center" class="pa-0" @click="openDialog('clearchat')">
        <v-icon class="icon-color-edit ma-2">fa-solid fa-xmark</v-icon>
        <br>
        <span class="icon-color-edit">{{ $t('RightSide.menu.clearChat') }}</span>
      </v-col>
      <v-col cols="3" justify="center" align="center" class="pa-0" @click="openDialog('member')">
        <v-icon :class="statemember === 'active' ? 'icon-color-edit ma-2' : 'icon-color-disable ma-2'">fa-solid
          fa-user-group</v-icon>
        <br>
        <span
          :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">{{ $t('RightSide.member') }}</span>
      </v-col>
      <v-col cols="3" justify="center" align="center" class="pa-0" @click="openDialog('invite')">
        <v-icon :class="statemember === 'active' ? 'icon-color-edit ma-2' : 'icon-color-disable ma-2'">fa-solid
          fa-user-plus</v-icon>
        <br>
        <span
          :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">{{ $t('Dialog.group.addMember') }}</span>
      </v-col>
      <v-col cols="3" justify="center" align="center" class="pa-0">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon :class="statemember === 'active' ? 'icon-color-edit cursor mb-1' : 'icon-color-disable mb-1'" v-bind="attrs" v-on="on">
              <v-icon :class="statemember === 'active' ? 'icon-color-edit ma-2 cursor' : 'icon-color-disable ma-2'">fa-solid fa-ellipsis-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item :disabled="statemember !== 'active'" @click="openDialog('qrcode')">
              <v-icon
                :class="statemember === 'active' ? 'icon-color-edit ma-2 cursor' : 'icon-color-disable ma-2'">fa-solid
                fa-qrcode</v-icon>
              <br>
              <span :class="statemember === 'active' ? 'icon-color-edit cursor' : 'icon-color-disable'">{{
                $t('RightSide.menu.qrCode') }}</span>
            </v-list-item>
            <v-list-item :disabled="statemember !== 'active'" @click="openDialog('leave')">
              <v-icon :class="statemember === 'active' ? 'icon-color-edit ma-2' : 'icon-color-disable ma-2'">fa-solid
                fa-arrow-right-from-bracket</v-icon>
              <br>
              <span
                :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">{{ $t('RightSide.menu.leave') }}</span>
            </v-list-item>
          </v-list>
        </v-menu>
        <br>
        <span :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">{{ $t('Dialog.group.moreDetail') }}</span>
      </v-col>
      <!-- <v-col cols="3" justify="center" align="center" class="pa-0" @click="openDialog('qrcode')">
                    <v-icon
                        :class="statemember === 'active' ? 'icon-color-edit ma-2 cursor' : 'icon-color-disable ma-2'">fa-solid fa-qrcode</v-icon>
                    <br>
                    <span
                        :class="statemember === 'active' ? 'icon-color-edit cursor' : 'icon-color-disable'">{{ $t('RightSide.menu.qrCode') }}</span>
                </v-col>
      <v-col
        cols="3"
        justify="center"
        align="center"
        class="pa-0"
        @click="openDialog('leave')"
      >
        <v-icon :class="statemember === 'active' ? 'icon-color-edit ma-2': 'icon-color-disable ma-2'">fa-solid fa-arrow-right-from-bracket</v-icon>
        <br>
        <span :class="statemember === 'active' ? 'icon-color-edit': 'icon-color-disable'">{{$t('RightSide.menu.leave')}}</span>
      </v-col> -->
    </v-layout>
    <v-divider class="mt-5 mb-3"></v-divider>
    <v-layout v-if="typeroom === 'user'" row wrap justify-center align-center class="mt-5 pl-3 pr-3">
      <!-- user -->
      <!-- image & file-->
      <!-- <v-col cols="12" justify="center">
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-icon class="pr-3 fz-20 icon-color-edit">fa-solid fa-file-image</v-icon>
          <b class="text-title-edit text-overflow">{{$t('RightSide.header.image')}} {{$t('Conjunction.and')}} {{$t('RightSide.header.file')}}</b>
          <v-spacer></v-spacer>
          <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
        </v-row>
        <v-row class="pl-3 pb-5 width-100" align="center">
          <v-col cols="4" v-for="n in 3" :key="n">
            <v-img
              :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
              :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
              aspect-ratio="1"
              class="grey lighten-2"
              style="border-radius: 20px;"
            >
            </v-img>
          </v-col>
        </v-row>
      </v-col> -->

      <!-- task in room -->
      <v-col cols="12" justify="center" class="mb-3">
          <v-row :class="statemember === 'active' ? 'pl-3 pb-2 width-100 cursor': 'pl-3 pb-2 width-100'" align="center" @click="statemember === 'active' ? openDialog('task') : ''">
              <v-icon
                  :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid fa-list</v-icon>
              <b
                  :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.project') }}</b>
              <v-spacer></v-spacer>
              <v-icon
                  :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
          </v-row>   
      </v-col>
      <!-- album -->
      <v-col cols="12" justify="center">
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-icon
            :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid
            fa-images</v-icon>
          <b
            :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.album') }}</b>
          <v-spacer></v-spacer>
          <v-icon :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
        </v-row>
        <!-- <v-row class="pl-3 pb-5 width-100" align="center" style="height: 100px;">
          <v-col cols="6" v-for="(n, index) in list_albums" :key="index">
            <v-img
              :src="n.pic_title"
              :lazy-src="n.pic_title"
              aspect-ratio="1"
              class="grey lighten-2"
              style="height: 100px; border-radius: 20px;"
              :class="statemember === 'active'? 'grey lighten-2' : 'image-disable grey lighten-2'"
              v-if="index <= 1"
            >
            <v-row align="end" class="ml-3" style="height: 100%;">
              <p class="text-title-image text-overflow mb-0">{{n.albums_name}}</p>
            </v-row>
            </v-img>
          </v-col>
        </v-row> -->
        <v-row @click="openDialog('albums')" v-if="list_albums.length !== 0" class="pl-3 pb-5 width-100" align="center"
          style="height: 100px;">
          <v-col :cols="list_albums.length == 1 ? 12 : 6" v-for="(item, index) in list_albums" :key="item._id">
            <v-img :src="item.pic_title" :lazy-src="item.pic_title" aspect-ratio="1" class="grey lighten-2"
              style="height: 100px; border-radius: 20px;"
              :class="statemember ? 'grey lighten-2' : 'image-disable grey lighten-2'" v-if="index <= 1">
              <v-row align="end" class="ml-3" style="height: 100%;">
                <p class="text-title-image text-overflow-album mb-0">{{ item.albums_name }}</p>
              </v-row>
            </v-img>
          </v-col>
        </v-row>
        <v-row @click="openDialog('albums')" class="pl-3 pb-5 width-100" align="center" v-else>
          <v-col cols="12" :class="statemember ? 'col-no-media' : 'col-no-media-not-active'" align="center"
            justify="center">
            <span>{{ $t('Dialog.album.noDataAlbum') }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" justify="center" class="mt-10">
        <!-- note -->
        <v-row class="pl-3 pb-2 width-100" align="center" @click="openDialog('note')">
          <v-icon
            :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid
            fa-note-sticky</v-icon>
          <b
            :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.note') }}</b>
          <v-spacer></v-spacer>
          <v-icon :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
        </v-row>
      </v-col>
    </v-layout>
    <v-layout v-else row wrap justify-center align-center class="mt-8 pl-3 pr-3">
      <!-- group -->
      <!-- image & file-->
      <!-- <v-col cols="12" justify="center">
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-icon class="pr-3 fz-20 icon-color-edit">fa-solid fa-file-image</v-icon>
          <b class="text-title-edit text-overflow">{{$t('RightSide.header.image')}} {{$t('Conjunction.and')}} {{$t('RightSide.header.file')}}</b>
          <v-spacer></v-spacer>
          <v-icon class="icon-color-edit">mdi-chevron-right</v-icon>
        </v-row>
        <v-row class="pl-3 pb-5 width-100" align="center">
          <v-col cols="4" v-for="n in 3" :key="n">
            <v-img
              :src="`https://picsum.photos/500/300?image=${n * 5 + 10}`"
              :lazy-src="`https://picsum.photos/10/6?image=${n * 5 + 10}`"
              aspect-ratio="1"
              class="grey lighten-2"
              style="border-radius: 20px;"
            >
            </v-img>
          </v-col>
        </v-row>
      </v-col> -->

      <!-- task in room -->
      <v-col cols="12" justify="center" class="mb-3">
          <v-row :class="statemember === 'active' ? 'pl-3 pb-2 width-100 cursor': 'pl-3 pb-2 width-100'" align="center" @click="statemember === 'active' ? openDialog('task') : ''">
              <v-icon
                  :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid fa-list</v-icon>
              <b
                  :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.project') }}</b>
              <v-spacer></v-spacer>
              <v-icon
                  :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
          </v-row>   
      </v-col>
      <!-- album -->
      <v-col cols="12" justify="center">
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-icon
            :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid
            fa-images</v-icon>
          <b
            :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.album') }}</b>
          <v-spacer></v-spacer>
          <v-icon :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
        </v-row>
        <!-- <v-row class="pl-3 pb-5 width-100" align="center" style="height: 100px;">
          <v-col cols="6" v-for="(n, index) in list_albums" :key="index">
            <v-img
              :src="n.pic_title"
              :lazy-src="n.pic_title"
              aspect-ratio="1"
              :class="statemember === 'active'? 'grey lighten-2' : 'image-disable grey lighten-2'"
              style="height: 100px; border-radius: 20px;"
              v-if="index <= 1"
            >
            <v-row align="end" class="ml-3" style="height: 100%;">
              <p class="text-title-image text-overflow mb-0">{{n.albums_name}}</p>
            </v-row>
            </v-img>
          </v-col>
        </v-row> -->
        <v-row @click="openDialog('albums')" v-if="list_albums.length !== 0" class="pl-3 pb-5 width-100" align="center"
          style="height: 100px;">
          <v-col :cols="list_albums.length == 1 ? 12 : 6" v-for="(item, index) in list_albums" :key="item._id">
            <v-img :src="item.pic_title" :lazy-src="item.pic_title" aspect-ratio="1" class="grey lighten-2"
              style="height: 100px; border-radius: 20px;"
              :class="statemember ? 'grey lighten-2' : 'image-disable grey lighten-2'" v-if="index <= 1">
              <v-row align="end" class="ml-3" style="height: 100%;">
                <p class="text-title-image text-overflow-album mb-0">{{ item.albums_name }}</p>
              </v-row>
            </v-img>
          </v-col>
        </v-row>
        <v-row @click="openDialog('albums')" class="pl-3 pb-5 width-100" align="center" v-else>
          <v-col cols="12" :class="statemember ? 'col-no-media' : 'col-no-media-not-active'" align="center"
            justify="center">
            <span>{{ $t('Dialog.album.noDataAlbum') }}</span>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" justify="center" class="mt-10">
        <!-- note -->
        <v-row class="pl-3 pb-2 width-100" align="center" @click="openDialog('note')">
          <v-icon
            :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid
            fa-note-sticky</v-icon>
          <b
            :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.note') }}</b>
          <v-spacer></v-spacer>
          <v-icon :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
        </v-row>
      </v-col>
      <v-col cols="12" justify="center" class="mt-5" @click="openDialog('setting')">
        <!-- setting -->
        <v-row class="pl-3 pb-2 width-100" align="center">
          <v-icon
            :class="statemember === 'active' ? 'pr-3 fz-20 icon-color-edit' : 'pr-3 fz-20 icon-color-disable'">fa-solid
            fa-gear</v-icon>
          <b
            :class="statemember === 'active' ? 'text-title-edit text-overflow' : 'icon-color-disable text-overflow'">{{ $t('RightSide.menu.setting') }}</b>
          <v-spacer></v-spacer>
          <v-icon :class="statemember === 'active' ? 'icon-color-edit' : 'icon-color-disable'">mdi-chevron-right</v-icon>
        </v-row>
      </v-col>
    </v-layout>
    <Warning :WarningDialog="WarningDialog" :WarningDialogDetail="WarningDialogDetail" @emitWarning="emitWarning"
      @closeAlertDialog="closeAlertDialog" />
    <ErrorAlert :ErrorDialog="ErrorDialog" :ErrorDialogDetail="ErrorDialogDetail"
      @closeAlertDialog="closeAlertDialog" />
    <SettingGroup :SettingGroupDialog="SettingGroupDialog" :SettingGroupDetail="SettingGroupDetail"
      @closeComponents="closeComponents" />
    <InviteMemberGroup :InviteMemberDialog="InviteMemberDialog" :InviteMemberDetail="InviteMemberDetail"
      @closeComponents="closeComponents" />
    <MemberGroup :MemberGroup="MemberGroup" :MemberGroupDetail="MemberGroupDetail" @closeComponents="closeComponents" />
    <NoteChat :NoteChatDialog="NoteChatDialog" :NoteChatDetail="NoteChatDetail" @closeComponents="closeComponents" />
    <AlbumsChat :AlbumsDialog="AlbumsDialog" :AlbumsRoom="tokenroom" :tokenuser="tokenuser"
      @closeComponents="closeComponents" />
      <Qrcode :dialogShowQRCode="QrcodeDialog" :detail="QrcodeDetail" @closeComponents="closeComponents"></Qrcode>
  </div>
</template>

<script>
import Warning from '@/components/Alert/Warning'
import ErrorAlert from '@/components/Alert/Error'
import MemberGroup from '@/components/MemberGroup'
import InviteMemberGroup from '@/components/InviteMemberGroup'
import SettingGroup from '@/components/SettingGroup'
import NoteChat from '@/components/NoteChat'
import AlbumsChat from '@/components/AlbumsChat'
import Qrcode from '@/components/QRCodeGroup.vue'
export default {
  data() {
    return {
      BASE_ENV: process.env.NODE_ENV,
      AlbumsDialog: false,
      NoteChatDialog: false,
      NoteChatDetail: {},
      SettingGroupDialog: false,
      SettingGroupDetail: {},
      InviteMemberDialog: false,
      InviteMemberDetail: {},
      MemberGroup: false,
      MemberGroupDetail: {},
      ErrorDialog: false,
      ErrorDialogDetail: {},
      WarningDialog: false,
      WarningDialogDetail: {},
      count_member: 0,
      progress: false,
      name_room: '',
      tokenroom: '',
      tokenuser: '',
      tokenfriend: '',
      typeroom: '',
      group_id: '',
      statemember: '',
      data_user: {},
      data_group: {},
      list_albums: [],
      stylechat: {
        "--ChatRoom-HeaderColor": "white",
        "--ChatRoom-TabBackground": "white",
        "--ChatRoom-Icon": "gray",
        "--ChatRoom-IconActive": "#2662ae",
        "--ChatRoom-Background": "white",
        "--ChatRoom-FontSize": "18px",
        "--ChatRoom-FontColor": "back",
        "--ChatRoom-FontColor-Edit": "white",
        "--ChatRoom-FontSize-Status": "16px",
        "--ChatRoom-FontColor-Status": "grey",
        "--ChatRoom-Background-Input": "#E2E1E3",
        "--ChatRoom-Color-Button": "#EFF2FE",
        "--ChatRoom-FontColor-Button": "#2662ae",
        "--ChatRoom-FontColor-Block-Button": "#cb1002",
        "--ChatRoom-FontSize-Title-Edit": "16px;",
        "--ChatRoom-Color-disable": "#8080806e",
      },
      QrcodeDialog: false,
      QrcodeDetail: {},
    }
  },
  components: {
    Warning,
    ErrorAlert,
    MemberGroup,
    InviteMemberGroup,
    SettingGroup,
    NoteChat,
    AlbumsChat,
    Qrcode,
  },
  created() {
    // var user_profile = JSON.parse(this.$cookie.get('user-profile'))
    var user_profile = ''
    if (JSON.parse(this.$cookie.get('user-profile') == null)) {
      user_profile = JSON.parse(localStorage.getItem('user-profile'))
    } else {
      user_profile = JSON.parse(this.$cookie.get('user-profile'))
    }
    this.data_user = user_profile['account']['profile']
    this.tokenuser = this.data_user.tokenuser
    this.tokenroom = this.$route.params.tokenroom
    this.typeroom = this.$route.params.type
    this.getRoom()
  },
  methods: {
    closeComponents(item) {
      if (item.name === 'membergroup') {
        this.MemberGroup = item.value
        this.getRoom()
      } else if (item.name === 'invitemember') {
        this.InviteMemberDialog = item.value
        this.getRoom()
      } else if (item.name === 'settinggroup') {
        this.SettingGroupDialog = item.value
        this.getRoom()
      } else if (item.name === 'notechat') {
        this.NoteChatDialog = item.value
      } else if (item.name === 'albumschat') {
        this.AlbumsDialog = item.value
        this.getRoom()
      } else if (item.name === 'qrcode') {
        this.QrcodeDialog = item.value
      }
    },
    openDialog(type) {
      if (this.statemember === 'active') {
        if (type === 'leave') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Right.leaveGroup'),
            detail: 'leave',
            index: 0
          }
          this.WarningDialog = true
        } else if (type === 'invite') {
          this.InviteMemberDialog = true
          this.InviteMemberDetail = this.data_group
        } else if (type === 'member') {
          this.MemberGroup = true
          this.MemberGroupDetail = this.data_group
        } else if (type === 'clearchat') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Right.clearChat'),
            detail: 'clearchat',
            index: 0
          }
          this.WarningDialog = true
        } else if (type === 'setting') {
          this.SettingGroupDialog = true
          this.SettingGroupDetail = this.data_group
        } else if (type === 'block') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Blocking', { name: this.name_room }),
            detail: 'block',
            index: 0
          }
          this.WarningDialog = true
        } else if (type === 'un-block') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Unblocking', { name: this.name_room }),
            detail: 'un-block',
            index: 0
          }
          this.WarningDialog = true
        } else if (type === 'note') {
          this.NoteChatDialog = true
          this.NoteChatDetail = {
            tokenroom: this.tokenroom,
            tokenuser: this.tokenuser
          }
        } else if (type == 'albums') {
          this.AlbumsDialog = true
        } else if (type === 'qrcode') {
          this.QrcodeDialog = true
        } else if (type === 'task') {
            this.$router.push(`/project/${this.tokenroom}/${this.typeroom}`)
        }
      } else {
        if (type === 'clearchat') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Right.clearChat'),
            detail: 'clearchat',
            index: 0
          }
          this.WarningDialog = true
        } else if (type === 'un-block') {
          this.WarningDialogDetail = {
            title: this.$t('Alert.Sure'),
            text: this.$t('Alert.Unblocking', { name: this.name_room }),
            detail: 'un-block',
            index: 0
          }
          this.WarningDialog = true
        }
      }
    },
    emitWarning(item) {
      // console.log(item)
      this.WarningDialog = false
      if (item.detail === 'leave') {
        this.leaveGroup()
      } else if (item.detail === 'clearchat') {
        this.clearChat()
      } else if (item.detail === 'block') {
        this.blockFriend()
      } else if (item.detail === 'un-block') {
        this.unBlockFriend()
      }
    },
    closeAlertDialog(data) {
      // console.log(data)
      if (data.type === 'warning') {
        this.WarningDialog = data.value
      } else if (data.type === 'err') {
        this.ErrorDialog = data.value
      }
    },
    close() {
      // this.$router.go(-1)
      this.$router.push(`/chat/${this.tokenroom}`)
      // this.$emit('closeComponents', false)
    },
    unBlockFriend() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/unblockfriend`, {
        tokenfriend: this.tokenfriend,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.statemember = 'active'
          // this.$router.push(`/chat/${this.tokenroom}`)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    blockFriend() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/blockfriend`, {
        tokenfriend: this.tokenfriend,
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.statemember = 'block'
          // this.$router.push(`/chat/${this.tokenroom}`)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    clearChat() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/setisactive`, {
        is_active: 'false',
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        if (response.data.status === 'success') {
          this.progress = false
          this.$router.push(`/chat/${this.tokenroom}`)
        } else {
          this.progress = false
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    leaveGroup() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_GO + `/v1/leave-group`, {
        tokenuser: this.tokenuser,
        group_id: this.group_id,
        listmember: [this.tokenuser]
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.$router.push('/listchat')
        } else {
          this.ErrorDialogDetail = {
            title: 'Error',
            text: this.$t('Alert.Fail.default.somethingWrong')
          }
          this.ErrorDialog = true
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
        this.ErrorDialogDetail = {
          title: 'Error',
          text: this.$t('Alert.Fail.default.somethingWrong')
        }
        this.ErrorDialog = true
      })
    },
    getRoom() {
      this.progress = true
      this.axios.post(process.env.VUE_APP_API_MANAGE + '/getroom', {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.statemember = response.data.statemember
          if (this.typeroom === 'group') {
            this.name_room = response.data.group_name
            this.count_member = response.data.count_member
            this.group_id = response.data.group_id
            this.QrcodeDetail = response.data
            this.getGroup(this.group_id)
          } else {
            this.name_room = response.data.data_room[0].name
            this.tokenfriend = response.data.data_room[0].tokenuser
          }
          this.getListAlbums()
        }
      }).catch(err => {
        this.progress = false
        console.log(err)
      })
    },
    getListAlbums() {
      this.axios.post(process.env.VUE_APP_API_EVENT + '/getlist_albums', {
        tokenroom: this.tokenroom,
        tokenuser: this.tokenuser
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.list_albums = response.data.data
          // console.log(this.list_albums)
        }
      }).catch(err => {
        this.progress = false
        console.log(err)
      })
    },
    getGroup(id) {
      this.axios.post(process.env.VUE_APP_API_MANAGE + `/getgroup`, {
        tokenuser: this.tokenuser,
        group_id: id
      }).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.progress = false
          this.data_group = response.data['group']
        }
      }).catch(err => {
        console.log(err)
        this.progress = false
      })
    },
  }
}
</script>

<style lang="css" scoped>
.col-no-media {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: gray;
}

.col-no-media-not-active {
  border-style: solid;
  border-width: thin;
  border-radius: 15px;
  background-color: #8080801c;
  border-color: #8080801c;
  height: 100px;
  align-items: center;
  justify-content: center;
  display: flex;
  color: #d7d7d7;
}

.text-overflow-album {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 30vw;
}

.fz-14 {
  font-size: 14px;
}

.image-disable {
  opacity: 0.5 !important;
}

.icon-color-disable {
  color: var(--ChatRoom-Color-disable) !important;
}

.text-title-edit {
  font-size: var(--ChatRoom-FontSize-Title-Edit) !important;
  color: var(--ChatRoom-FontColor) !important;
}

.text-title-image {
  font-size: var(--ChatRoom-FontSize-Title-Edit) !important;
  color: var(--ChatRoom-FontColor-Edit) !important;
}

.width-100 {
  width: 100% !important;
}

.btn-color {
  color: var(--ChatRoom-FontColor-Button) !important;
  text-transform: none !important;
  border-radius: 10px !important;
  min-width: 125px !important;
}

.btn-color-block {
  color: var(--ChatRoom-FontColor-Block-Button) !important;
  text-transform: none !important;
  border-radius: 10px !important;
  min-width: 125px !important;
}

.icon-color {
  color: var(--ChatRoom-IconActive) !important;
}

.icon-color-edit {
  color: var(--ChatRoom-Icon) !important;
}

.fz-18 {
  font-size: 18px !important;
}

.fz-20 {
  font-size: 20px !important;
}

.fz-30 {
  font-size: 30px !important;
}

.layout-listchat {
  height: calc(100vh - 106px) !important;
  overflow-y: auto;
  /* background-color: bisque; */
  width: 100% !important;
}

.layout-listchat::-webkit-scrollbar {
  width: 4px;
}

.layout-listchat::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: rgba(0, 0, 0, .1);
}

>>>.pull-down-container {
  /* padding: 0px !important; */
  /* overflow-y: hidden !important; */
  height: unset !important;
  max-height: unset !important;
  overflow-x: hidden !important;
  overflow-y: auto !important;
}

>>>.pull-down-container::-webkit-scrollbar {
  height: 10px;
  width: 0px;
}

>>>.pull-down-header {
  width: 100%;
  height: 0px;
  overflow: hidden;
  position: relative;
  background-color: var(--ChatRoom-Background) !important;
}

>>>.pull-down-content {
  position: absolute;
  max-width: 90%;
  bottom: 10px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  height: 40px;
  color: #0054ad;
  text-align: center;
  border-left: 20px solid transparent;
  font-family: "noto-thin", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.tab-title {
  color: var(--ChatRoom-FontColor) !important;
  font-size: var(--ChatRoom-FontSize) !important;
  font-weight: 600;
}

.tab-title-status {
  color: var(--ChatRoom-FontColor-Status) !important;
  font-size: var(--ChatRoom-FontSize-Status) !important;
}

.text-overflow {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  width: 70vw;
}

.img-position {
  object-fit: cover;
  object-position: 50% 0;
  border-style: solid;
  border-width: thin;
  border-color: #e8e8e8;
}

>>>.v-input__slot {
  background-color: var(--ChatRoom-Background-Input) !important;
  border-radius: 10px !important;
}

>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  box-shadow: none !important;
}

.tab-title {
  color: var(--ChatRoom-FontColor) !important;
  font-size: var(--ChatRoom-FontSize) !important;
  font-weight: 600;
}

.span-color {
  color: var(--ChatRoom-FontColor) !important;
  font-size: var(--ChatRoom-FontSize) !important;
}

.layout-page {
  height: 100vh !important;
  overflow: hidden !important;
  background-color: var(--ChatRoom-Background) !important;
}
</style>
